<template>
    <div class="finsh-page">
        <el-row>
            <el-col :span="24">
                <div class="grid-content">
                    <el-col :span="12" :offset="6">
                        <div class="grid-content">
                            <div class="section">
                                <div v-if="viewType === 'success'">
                                    <el-alert
                                            :title="$t('rechargeFinish')"
                                            type="success"
                                            :description="$t('rechargeFinishCheckLater')"
                                            show-icon>
                                    </el-alert>
                                    <el-card class="box-card">
                                        <div class="text item">
                                            <div>{{ $t('orderId') }}: {{ order_id }}</div>
                                            <br>
                                            <div>{{ $t('rechargeAmount') }}: {{ recharge_amount }} {{ currency }}</div>
                                        </div>
                                    </el-card>
                                </div>
                                <div v-if="viewType === 'finsh'">
                                    <el-alert
                                            :title="$t('rechargeFinish')"
                                            type="success"
                                            :description="$t('rechargeFinishCheckLater')"
                                            show-icon>
                                    </el-alert>
                                    <el-card class="box-card">
                                        <div class="text item">
                                            <div>{{ $t('orderId') }}:{{ order_id }}</div>
                                            <br>
                                        </div>
                                    </el-card>
                                </div>
                                <div v-if="viewType === 'fail'">
                                    <el-alert
                                            :title="$t('rechargeFail')"
                                            type="warning"
                                            :description="$t('rechargeFailErrCode')"
                                            show-icon>
                                    </el-alert>
                                    <el-card class="box-card">
                                        <div>code: {{ code }}</div>
                                        <br>
                                        <div>{{ $t('orderId') }}: {{ order_id }}</div>
                                    </el-card>
                                </div>
                                <div id="test" style="display: none;" @click="heights">位置</div>
                                <div id="close" @click="closes">关闭</div>
                            </div>
                        </div>
                    </el-col>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                viewType:'',
                code:0,
                order_id:0,
                currency:0,
                recharge_amount:0,
            };
        },
        methods: {
            heights(){
                var contentHeight = $(window).height()/30 +'%';
                $(".section").css("margin-top", ''+contentHeight+'');
            },
            clicks(){
                setTimeout("$('#test').trigger('click')",200);
                setTimeout("$('#close').trigger('click')",5000);
            },
            closes(){
                console.log(this.$route.query.type);
                window.close();
            }
        },
        created(){
            this.clicks();
            var type = this.$route.query.type;
            var code = this.$route.query.code;
            var order_id = this.$route.query.order_id;
            var currency = this.$route.query.currency;
            var recharge_amount = this.$route.query.recharge_amount;
            this.viewType = type;
            this.code = code;
            this.order_id = order_id;
            this.currency = currency;
            this.recharge_amount = recharge_amount;

        }
    };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../assets/scss/lib.scss";
    .el-row {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }
    .row-bg {
        background-color: #f9fafc;
    }

    .text {
        font-size: 14px;
    }

    .item {
        padding: 18px 0;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }

    .box-card {
        margin: 0 auto;
        width: 480px;
    }

</style>



// WEBPACK FOOTER //
// Result.vue?0bb0d218